import mixpanel from 'mixpanel-browser';
import { storage as LocalStorage } from "services/config/storage";

// mixpanel.init("a351faf65cb6fc16d274992587feb9b9"); --> freadom
mixpanel.init("18af43000658ff29f1e5ce5d001de7b1");

let env_check = process.env.NODE_ENV === 'production';
// let env_check = true;

let payload = {
  childData: LocalStorage.fetch.childData() ? LocalStorage.fetch.childData().list : '',
  parentData: LocalStorage.fetch.parentData(),
  selectedChild: LocalStorage.fetch.defaultChild()
}

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  // track: (name, props) => {
  //   if (env_check) mixpanel.track(name, {...payload, ...props});
  // },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;
